<template>
    <div>
        <el-form :inline="true" ref="form" @submit.native.prevent="onSubmit">
            <!-- 类目：由畅销排行接口返回 -->
            <el-form-item label="类目：" class="query-form-item">
                <el-select v-model="query.keepa_category_id" placeholder="请选择类目" size="mini" style="width: 220px;" filterable clearable>
                    <el-option :label="item.name" :value="item.id" v-for="item in categoryOptions" :key="item.id"></el-option>
                </el-select>
            </el-form-item>

            <!-- 月份：yyyy-MM -->
            <el-form-item label="月份：" class="query-form-item">
                <el-date-picker
                    v-model="query.year_month"
                    type="month"
                    size="mini"
                    clearable
                    placeholder="选择月份"
                    value-format="yyyy-MM"
                    format="yyyy-MM"
                    style="width: 140px"
                />
            </el-form-item>

            <el-button type="primary" @click="onSubmit" size="mini" style="margin-top: 5px" native-type="submit">查询</el-button>
            <el-button @click="onReset" size="mini" style="margin-top: 5px">重置</el-button>
        </el-form>

        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            class="table_content mini_div"
            border
            style="width: 100%;"
        >
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.image">
                        <img style="width:90px;height:90px;" src="../../assets/image/noPic.png"/>
                    </div>
                    <img style="width:90px;height:90px;" :src="scope.row.image" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="排名" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rank }}</div>
                </template>
            </el-table-column>

<!--            <table-asin-column></table-asin-column>-->


            <el-table-column label="Asin" width="200" align="center">
                <template slot-scope="scope">
                    <div class="asinBox">
                        <span v-if="scope.row.asin != null" @click.stop="jumpAmazon(scope.row)"
                                  style="cursor: pointer;color: rgb(52, 73, 94);">
                                <i class="el-icon-s-promotion" style="margin-right:5px;"></i>
                            </span>
                        <icon-svg
                            v-if="scope.row.country"
                            :icon-class="(scope.row.country || '').toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                        <span
                            @click="jumpAmazon(scope.row)"
                            style="color: blue;cursor: pointer"
                        >{{ scope.row.asin }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="信息" min-width="420" align="center">
                <template slot-scope="scope">
                    <div style="text-align: left">
                        <div style="font-size: 16px; font-weight: 600;">{{ scope.row.title || '-' }}</div>
                        <div style="display: flex" v-show="scope.row.rating">
                            <el-rate
                                v-model="scope.row.ratingNum"
                                disabled
                                text-color="#ff9900"
                            />
                            <div style="color: rgb(247, 186, 42)">{{ scope.row.rating }}</div>
                        </div>
                        <div style="font-size: 15px; font-weight: 600;" v-if="scope.row.price">{{ scope.row.price }}</div>
                        <!-- 参考 operatingList 的基础信息，但去掉你说的“划线项”（先不展示价格/更新时间/bsr 等，后面按接口字段再补） -->
                        <div style="font-size: 12px; font-weight: 600;">品牌：{{ scope.row.brand || '-' }}</div>
                        <div style="font-size: 12px; font-weight: 600;">评论数：{{ scope.row.review_count || '-' }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="规格" min-width="180" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.specification || '-' }}</div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :current-page="query.page"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px;"
            layout="total, sizes, prev, pager, next"
        />
    </div>
</template>

<script>
import * as api from '@/api/extraTool/bestsellerRankAsins'

export default {
    name: 'BestsellerRankAsins',
    data() {
        return {
            tableHeight: null,
            loading: false,
            categoryOptions: [],
            query: {
                keepa_category_id: '',
                year_month: '',
                page: 1,
                limit: 20,
                total: 0
            },
            list: []
        }
    },
    created() {
        this.query.year_month = this.getDefaultYearMonth()
        this.getCategoryOptions()
    },
    mounted() {
        this.tableHeight = window.innerHeight - 140 - (this.$refs.form ? this.$refs.form.$el.offsetHeight : 0)
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight = window.innerHeight - 140 - that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    methods: {
         edirectToAsin(data) {
            window.open(data.image, '_blank')
        },
        // 默认：前两个月（例如 2025-12-30 => 2025-10； 2026-01-01 => 2025-11）
        getDefaultYearMonth() {
            const d = new Date()
            const year = d.getFullYear()
            const monthIndex = d.getMonth() // 0-11
            const target = new Date(year, monthIndex - 2, 1)
            const y = target.getFullYear()
            const m = String(target.getMonth() + 1).padStart(2, '0')
            return `${y}-${m}`
        },
        adjustNumber(num) {
            let integerPart = Math.floor(num)
            let decimalPart = Number(((num - integerPart).toFixed(1)))
            if (decimalPart >= 0 && decimalPart < 0.3) return integerPart
            if (decimalPart >= 0.3 && decimalPart < 0.8) return integerPart + 0.5
            if (decimalPart >= 0.8 && decimalPart < 1) return integerPart + 1
            return num
        },
        formatSpec(item) {
            if (item.long || item.wide || item.height || item.weight) {
                return `${item.long || '-'}*${item.wide || '-'}*${item.height || '-'}-${item.weight || '-'}`
            }
            return '--'
        },
        async getCategoryOptions() {
            try {
                const res = await api.getBestsellerRankAsinCategoryMessage({})
                const list = (res && (res.data || res.message || res.list)) || []

                this.categoryOptions = (Array.isArray(list) ? list : []).map(i => ({
                    id: i.id || i.keepa_category_id,
                    name: i.name || i.category_name || i.title
                })).filter(i => i.id)

                // 默认选中第一个
                if (!this.query.keepa_category_id && this.categoryOptions.length > 0) {
                    this.query.keepa_category_id = this.categoryOptions[0].id
                    this.getList()
                }
            } catch (e) {
                this.$message.error('获取类目失败')
            }
        },
        jumpAmazon(row) {
            // 优先用接口给的 url
            if (row.asin_url) {
                window.open(row.asin_url, '_blank')
                return
            }
            // 否则按国家拼
            const state = (row.country || '').toLowerCase()
            const asin = row.asin
            if (!state || !asin) return
            let url = ''
            switch (state) {
                case 'us': url = 'https://www.amazon.com/dp/' + asin; break
                case 'uk': url = 'https://www.amazon.co.uk/dp/' + asin; break
                case 'de': url = 'https://www.amazon.de/dp/' + asin; break
                case 'fr': url = 'https://www.amazon.fr/dp/' + asin; break
                case 'it': url = 'https://www.amazon.it/dp/' + asin; break
                case 'es': url = 'https://www.amazon.es/dp/' + asin; break
                case 'ca': url = 'https://www.amazon.ca/dp/' + asin; break
                case 'mx': url = 'https://www.amazon.mx/dp/' + asin; break
                case 'br': url = 'https://www.amazon.br/dp/' + asin; break
                case 'nl': url = 'https://www.amazon.nl/dp/' + asin; break
                case 'se': url = 'https://www.amazon.se/dp/' + asin; break
                case 'pl': url = 'https://www.amazon.pl/dp/' + asin; break
                case 'be': url = 'https://www.amazon.be/dp/' + asin; break
                case 'tr': url = 'https://www.amazon.tr/dp/' + asin; break
            }
            url && window.open(url, '_blank')
        },
        getList() {
            if (!this.query.keepa_category_id) {
                this.$message.warning('请选择类目')
                return
            }
            if (!this.query.year_month) {
                this.$message.warning('请选择月份')
                return
            }

            this.loading = true
            const tempQuery = JSON.parse(JSON.stringify(this.query))

            api.getBestsellerRankAsinsList({
                keepa_category_id: tempQuery.keepa_category_id,
                year_month: tempQuery.year_month,
                page: tempQuery.page,
                limit: tempQuery.limit
            }).then(res => {
                this.loading = false
                if (res && (res.code === 0 || res.success)) {
                    const rows = (res.data && (res.data.list || res.data)) || res.list || []
                    const arr = Array.isArray(rows) ? rows : []

                    this.list = arr.map(i => {
                        const rating = i.rating || i.star
                        return {
                            image: i.amazon_img_url,
                            rank: i.rank,
                            asin: i.asin,
                            country: i.state,
                            asin_url: '',
                            title: i.title,
                            brand: i.brand,
                            price: i.price,
                            rating: i.rating,
                            ratingNum: this.adjustNumber(Number(i.rating) || 0),
                            review_count: i.rating_count,
                            long: i.long,
                            wide: i.wide,
                            height: i.height,
                            weight: i.weight,
                            specification: this.formatSpec(i)
                        }
                    })

                    this.query.total = (res.data && res.data.total) || res.total || 0
                } else {
                    this.$message({ type: 'error', message: (res && res.message) || '获取列表失败' })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 重置（允许清空筛选，但这里按需求恢复为默认值）
        onReset() {
            this.query = {
                keepa_category_id: this.categoryOptions.length > 0 ? this.categoryOptions[0].id : '',
                year_month: this.getDefaultYearMonth(),
                page: 1,
                limit: 20,
                total: 0
            }
            this.getList()
        },
        // 查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 8px !important;
    }

    .asinBox {
        position: relative;
        padding-top: 8px;
    }
</style>
